<script setup lang="ts">
import axios from 'axios';
import { computed, onMounted, ref, watch } from 'vue';

const props = defineProps<{
    userId?: number | null;
    period: string;
}>();

const count = ref<number | undefined>(undefined);

async function loadData(): Promise<void> {
    const response = await axios.get('/stats/quote_count', { params: { user_id: props.userId ?? null, period: props.period } });
    count.value = response.data.count;
}

onMounted(loadData);
watch(() => [props.userId, props.period], loadData);
</script>

<template>
    <div>
        <p v-if="count !== undefined">{{ count }}</p>
        <div v-else class="spinner-border" role="status"><span class="sr-only">Laddar</span></div>
    </div>
</template>

<style scoped>
p { font-size: 1.5em; }
</style>
